export default "__VITE_ASSET__BFQ1tA2E__"